// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vpc-main {
    position: relative;
    border: 1px dashed slategray;
}

.vpc-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 50%;
    background-color: black;
}

.vpc-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.vpc-choices-wrapper {
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
}

.vpc-choices-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    /*opacity: 0;*/
    /*visibility: hidden;*/
    bottom: 40px;
    z-index: 9;
    padding: 0 15px;
    width: 100%;
    /*height: 100%;*/
    position: unset !important;
    /*margin-bottom: 40px;*/
}

.vpc-choice-box {
    display: flex;
    align-items: stretch;
    justify-content: center;
    -moz-column-gap: 20px;
         column-gap: 20px;
    width: 100%;
    /*height: 175px;*/
    margin-bottom: 10px;
}

.vpc-choice-card-wrapper {
    width: 100%; /* Occupy the entire width of the parent */
    padding-top: 14%; /* Set the aspect ratio (height/width * 100) */
    position: relative;
}

.vpc-choice-card {
    background: #fff;
    border: 1px solid #D9D9D9;
    border-radius: 10px;
    overflow: hidden;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    /*max-width: 300px;*/
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 3px 0px rgb(0 0 0 / 50%);
    /*margin: 3px 0;*/
    /*position: relative;*/
    cursor: move;
}

.vpc-choice-card .vpc-choice-img {
    height: calc(100% - 25px);
    /*max-height: 145px;*/
    width: 100%;
    overflow: hidden;
    /*height: auto;*/
}

/*@media (max-width: 1440px) {*/
/*    .vpc-choice-card .vpc-choice-img {*/
/*        max-height: 130px;*/
/*    }*/
/*}*/

/*@media (max-width: 1200px) {*/
/*    .vpc-choice-card .vpc-choice-img {*/
/*        max-height: 120px;*/
/*    }*/
/*}*/

/*@media (max-width: 1000px) {*/
/*    .vpc-choice-card .vpc-choice-img {*/
/*        max-height: 110px;*/
/*    }*/
/*}*/

/*@media (max-width: 800px) {*/
/*    .vpc-choice-card .vpc-choice-img {*/
/*        max-height: 100px;*/
/*    }*/
/*}*/

/*@media (max-width: 768px) {*/
/*    .vpc-choice-card .vpc-choice-img {*/
/*        max-height: 70px;*/
/*    }*/
/*}*/

/*@media (max-width: 600px) {*/
/*    .video_choices .choice-box .choice-card .choice-img {*/
/*        max-height: 60px;*/
/*    }*/
/*}*/


/*@media (max-width: 512px) {*/
/*    .vpc-choice-card .vpc-choice-img {*/
/*        max-height: 50px;*/
/*    }*/
/*}*/

/*@media (max-width: 425px) {*/
/*    .vpc-choice-card .vpc-choice-img {*/
/*        max-height: 40px;*/
/*    }*/
/*}*/

.vpc-choice-card p {
    padding: 2px 5px;
    margin-bottom: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    font-size: 16px;
    color: black;
}

@media (max-width: 768px) {
    .vpc-choice-card .vpc-choice-img {
        height: calc(100% - 22px);
    }

    .vpc-choice-card p {
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/createInteractiveVideo/position-choices/position-choices.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,qBAAgB;SAAhB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,0CAA0C;IACvD,gBAAgB,EAAE,8CAA8C;IAChE,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B,yCAAyC;AACzC,6BAA6B;AAC7B,QAAQ;AACR,IAAI;;AAEJ,+BAA+B;AAC/B,yCAAyC;AACzC,6BAA6B;AAC7B,QAAQ;AACR,IAAI;;AAEJ,+BAA+B;AAC/B,yCAAyC;AACzC,6BAA6B;AAC7B,QAAQ;AACR,IAAI;;AAEJ,8BAA8B;AAC9B,yCAAyC;AACzC,6BAA6B;AAC7B,QAAQ;AACR,IAAI;;AAEJ,8BAA8B;AAC9B,yCAAyC;AACzC,4BAA4B;AAC5B,QAAQ;AACR,IAAI;;AAEJ,8BAA8B;AAC9B,4DAA4D;AAC5D,4BAA4B;AAC5B,QAAQ;AACR,IAAI;;;AAGJ,8BAA8B;AAC9B,yCAAyC;AACzC,4BAA4B;AAC5B,QAAQ;AACR,IAAI;;AAEJ,8BAA8B;AAC9B,yCAAyC;AACzC,4BAA4B;AAC5B,QAAQ;AACR,IAAI;;AAEJ;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".vpc-main {\n    position: relative;\n    border: 1px dashed slategray;\n}\n\n.vpc-wrapper {\n    position: relative;\n    width: 100%;\n    height: 0;\n    padding-top: 50%;\n    background-color: black;\n}\n\n.vpc-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.vpc-choices-wrapper {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    position: absolute;\n    overflow: hidden;\n    display: flex;\n    align-items: flex-end;\n}\n\n.vpc-choices-content {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n    /*opacity: 0;*/\n    /*visibility: hidden;*/\n    bottom: 40px;\n    z-index: 9;\n    padding: 0 15px;\n    width: 100%;\n    /*height: 100%;*/\n    position: unset !important;\n    /*margin-bottom: 40px;*/\n}\n\n.vpc-choice-box {\n    display: flex;\n    align-items: stretch;\n    justify-content: center;\n    column-gap: 20px;\n    width: 100%;\n    /*height: 175px;*/\n    margin-bottom: 10px;\n}\n\n.vpc-choice-card-wrapper {\n    width: 100%; /* Occupy the entire width of the parent */\n    padding-top: 14%; /* Set the aspect ratio (height/width * 100) */\n    position: relative;\n}\n\n.vpc-choice-card {\n    background: #fff;\n    border: 1px solid #D9D9D9;\n    border-radius: 10px;\n    overflow: hidden;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    /*max-width: 300px;*/\n    width: 100%;\n    height: 100%;\n    box-shadow: 0px 0px 3px 0px rgb(0 0 0 / 50%);\n    /*margin: 3px 0;*/\n    /*position: relative;*/\n    cursor: move;\n}\n\n.vpc-choice-card .vpc-choice-img {\n    height: calc(100% - 25px);\n    /*max-height: 145px;*/\n    width: 100%;\n    overflow: hidden;\n    /*height: auto;*/\n}\n\n/*@media (max-width: 1440px) {*/\n/*    .vpc-choice-card .vpc-choice-img {*/\n/*        max-height: 130px;*/\n/*    }*/\n/*}*/\n\n/*@media (max-width: 1200px) {*/\n/*    .vpc-choice-card .vpc-choice-img {*/\n/*        max-height: 120px;*/\n/*    }*/\n/*}*/\n\n/*@media (max-width: 1000px) {*/\n/*    .vpc-choice-card .vpc-choice-img {*/\n/*        max-height: 110px;*/\n/*    }*/\n/*}*/\n\n/*@media (max-width: 800px) {*/\n/*    .vpc-choice-card .vpc-choice-img {*/\n/*        max-height: 100px;*/\n/*    }*/\n/*}*/\n\n/*@media (max-width: 768px) {*/\n/*    .vpc-choice-card .vpc-choice-img {*/\n/*        max-height: 70px;*/\n/*    }*/\n/*}*/\n\n/*@media (max-width: 600px) {*/\n/*    .video_choices .choice-box .choice-card .choice-img {*/\n/*        max-height: 60px;*/\n/*    }*/\n/*}*/\n\n\n/*@media (max-width: 512px) {*/\n/*    .vpc-choice-card .vpc-choice-img {*/\n/*        max-height: 50px;*/\n/*    }*/\n/*}*/\n\n/*@media (max-width: 425px) {*/\n/*    .vpc-choice-card .vpc-choice-img {*/\n/*        max-height: 40px;*/\n/*    }*/\n/*}*/\n\n.vpc-choice-card p {\n    padding: 2px 5px;\n    margin-bottom: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: center;\n    font-size: 16px;\n    color: black;\n}\n\n@media (max-width: 768px) {\n    .vpc-choice-card .vpc-choice-img {\n        height: calc(100% - 22px);\n    }\n\n    .vpc-choice-card p {\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
